import React from "react"
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { Toaster } from "react-hot-toast"
import { AuthProvider } from "./contexts/AuthContext"
import { UserProvider } from "./contexts/UserContext"
import { OnboardingProvider } from "./contexts/OnboardingContext"
import ProtectedRoute from "./components/ProtectedRoute"
import LoginPage from "./pages/Loginpage"
import HomePage from "./pages/HomePage"
import RegisterPage from "./pages/Registerpage"
import Dashboard from "./pages/Dashboard"
import PricingPage from "./pages/PricingPage"
import JobPublicPage from "./pages/JobPublicPage"
import DashboardJobPage from "./pages/DashboardJobPage"
import mixpanel from "mixpanel-browser"

mixpanel.init("YOUR_PROJECT_TOKEN", {
  debug: process.env.NODE_ENV === "development",
  track_pageview: true,
  persistence: "localStorage",
})

export default function App() {
  return (
    <AuthProvider>
      <UserProvider>
        <OnboardingProvider>
        <BrowserRouter>
          <Toaster
            position="top-center"
            toastOptions={{
              duration: 3000,
              style: {
                fontFamily: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
                fontSize: 13,
                fontWeight: 600,
                background: "#161616",
                color: "#ffffff",
                border: "1px solid #2a2a2a",
              },
            }}
          />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/jobs/:jobId" element={<JobPublicPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Navigate to="/dashboard/home" replace />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/home"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/entry-level"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/applications"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/wild"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/inbox"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/profile"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/jobs/:jobId"
              element={
                <ProtectedRoute>
                  <DashboardJobPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        </OnboardingProvider>
      </UserProvider>
    </AuthProvider>
  )
}
